<template>
  <div style="height: 100%">
    <el-row style="height:60px;line-height:60px;width: 100%;background:#444444;
  position: absolute;
  top: 0;">
      <el-col :span="2" :offset="1"
        ><el-image
          style="
            width: 60px;
            height: 60px;
            margin-top: 0px;
          "
          :src="logourl"
          fit="contain"
        ></el-image
      ></el-col>
      <el-col
        :span="5"
        style="color:#ffd04b; font-size: 18px; font-weight: 600;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;"
        >搭搭乐高租赁管理平台</el-col
      >
      <!-- <el-col :span="11" >

      </el-col> -->
      <el-col :span="2" :offset="14" style="text-align:right">
        <el-dropdown  size="small" style="margin-right:30px;font-size:0.875rem" @command="handleCommand">
  <span class="el-dropdown-link">
    {{user.name}}<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
  <el-dropdown-menu slot="dropdown">
    <el-dropdown-item command="setPassword">重设密码</el-dropdown-item>
    <el-dropdown-item command="logoff" >登出</el-dropdown-item>
  </el-dropdown-menu>
</el-dropdown>
        <!-- <el-button type="text" @click="logOff()" style="font-size:0.875rem">登出</el-button> -->
      </el-col>
    </el-row>
    <el-row style="margin-top:60px; height: calc(100% - 60px); position: relative">
      <el-col :style="{width:isCollapse?'56px':'200px'}">
        <el-button :class="isCollapse?'el-icon-d-arrow-right':'el-icon-d-arrow-left'" style="width:100%; background:rgb(66, 72, 91);color:#ffffff;border:0" @click="isCollapse=!isCollapse"></el-button>
        <el-menu
          :collapse="isCollapse"
          :default-active="activeIndex"
          class="el-menu-demo"
          text-color="#ffffff"
          active-text-color="#ffd04b"
          unique-opened
          @select="handleSelect"
          background-color="#42485b"
          :router="false"
          style="font-size:14px;border-right:0"
        >
     <el-submenu
            index="DataShow" route="DataShow">
            <template slot="title">
              <i class="el-icon-s-grid"></i>
              <span slot="title">{{ $t("index.overview") }}</span>
            </template>
            <el-menu-item index="DataShow">{{ $t("index.overview") }}</el-menu-item>
          </el-submenu>
          <el-submenu  index="customer" route="CustomerList">
            <template slot="title">
              <i class="el-icon-user"></i>
              <span slot="title">{{ $t("index.customer") }}</span>
            </template>
            <el-menu-item 
              index="CustomerList">{{ $t("index.customerList") }}</el-menu-item>
            <el-menu-item 
              index="SubRole">订阅规则</el-menu-item>
             <el-menu-item 
              index="MoneyRole">储值规则</el-menu-item>
               <el-menu-item 
              index="MoneyHistory">储值消费明细</el-menu-item>
          </el-submenu>
        <el-submenu index="device" route="Devices">
      <template slot="title">
      <i class="el-icon-monitor"></i>
      <span slot="title">产品管理</span>
      </template>
      <el-menu-item index="ProductList">产品列表</el-menu-item>
       <el-menu-item index="ProductAge">年龄分类</el-menu-item>
       <el-menu-item index="ProductClass">主题管理</el-menu-item>
       <el-menu-item index="ProductTenancy">租期管理</el-menu-item>
       <el-menu-item index="ProductPcs">颗粒分类</el-menu-item>
       <el-menu-item index="Version">产品评价</el-menu-item>
      </el-submenu>
      <el-submenu index="factory" route="Factory">
      <template slot="title">
      <i class="el-icon-office-building"></i>
      <span slot="title">店铺管理</span>
      </template>
       <el-menu-item index="Factory">店铺列表</el-menu-item>
      </el-submenu>
          <el-submenu index="produce" route="Produce">
            <template slot="title">
              <i class="el-icon-setting"></i> <span>订单管理</span></template>
              <el-menu-item index="Produce"  ><span>手工下单</span></el-menu-item>
            <el-menu-item index="Produce"  ><span>订单列表</span></el-menu-item>
              <el-menu-item index="Produce"  ><span>储值列表</span></el-menu-item>
                <el-menu-item index="Produce"  ><span>订阅列表</span></el-menu-item>
          </el-submenu>
          <el-submenu index="setup" route="Produce">
            <template slot="title">
              <i class="el-icon-setting"></i> <span>系统设置</span></template>
            <el-menu-item index="Produce"  ><span>内容管理</span></el-menu-item>
              <el-menu-item index="Produce"  ><span>基础设置</span></el-menu-item>
                <el-menu-item index="Produce"  ><span>职员管理</span></el-menu-item>
                <el-menu-item index="Produce"  ><span>角色管理</span></el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
      <el-col :style="{width:isCollapse?'calc(100% - 56px)':'calc(100% - 200px)'}" style="height:100%">
         <router-view style="width:100%;height:100%; position: relative;overflow:auto" />
      </el-col>
    </el-row>

  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      isCollapse: false,
      memuWidth: 200,
      user: {},
      logourl: './static/images/logo.png'
    }
  },
  mounted: function () {
    var self = this
    let user = window.localStorage.getItem('customer')
    if (!user) {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'error'
      })
      self.$router.push({ name: 'Login' })
    } else{
      this.user = JSON.parse(user)
    }
  },
  computed: {
    activeIndex () {
      console.log(this.$route.name)
      return this.$route.name
    }
  },
  methods: {
    logOff () {
      window.localStorage.removeItem('store')
      window.localStorage.removeItem('sessionid')
      window.localStorage.removeItem('customer')
      this.$router.push('Login')
    },
    handleSelect (key) {
      this.$router.push('/'+key)
    },
    handleCommand (commmand) {
      switch (commmand) {
        case 'logoff':
          this.logOff()
          break
        case 'setPassword':
          this.$router.push({ name: 'Password' })
          break
      }
    }
  }
}

Date.prototype.Format = function (formatStr) {
  var str = formatStr
  var Week = ['日', '一', '二', '三', '四', '五', '六']

  str = str.replace(/yyyy|YYYY/, this.getFullYear())
  str = str.replace(
    /yy|YY/,
    this.getYear() % 100 > 9
      ? (this.getYear() % 100).toString()
      : '0' + (this.getYear() % 100)
  )

  str = str.replace(
    /MM/,
    this.getMonth() > 8 ? this.getMonth() + 1 : '0' + (this.getMonth() + 1)
  )
  str = str.replace(/M/g, this.getMonth())

  str = str.replace(/w|W/g, Week[this.getDay()])

  str = str.replace(
    /dd|DD/,
    this.getDate() > 9 ? this.getDate().toString() : '0' + this.getDate()
  )
  str = str.replace(/d|D/g, this.getDate())

  str = str.replace(
    /hh|HH/,
    this.getHours() > 9 ? this.getHours().toString() : '0' + this.getHours()
  )
  str = str.replace(/h|H/g, this.getHours())
  str = str.replace(
    /mm/,
    this.getMinutes() > 9
      ? this.getMinutes().toString()
      : '0' + this.getMinutes()
  )
  str = str.replace(/m/g, this.getMinutes())

  str = str.replace(
    /ss|SS/,
    this.getSeconds() > 9
      ? this.getSeconds().toString()
      : '0' + this.getSeconds()
  )
  str = str.replace(/s|S/g, this.getSeconds())

  return str
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-col {
  text-align: left;
}

</style>
<style>
 .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }

.el-dropdown-link {
    cursor: pointer;
    color: #ffd04b;
  }

/* .el-menu-item,
.el-submenu {
  height: 4.375rem;
  line-height: 4.375rem;
  font-size: 0.875rem;
  text-align: center;
}

.el-menu-item div {
  height: 1.25rem;
  line-height: 1.25rem;
} */

.el-submenu .el-menu-item{
  background-color:#333744 !important;
  text-align:center;
}

.el-submenu__title{
  font-size:14px;
}
.el-submenu__icon-arrow{
  font-size: 16px;
}

.el-submenu__title i,
.el-menu-item i{
  color:#ffffff;
}

</style>
<style>
  .el-breadcrumb{
    height:40px;
    line-height:40px !important;
    padding-left:30px;
    background: #eeeeee;
  }

  .el-form{
    padding:20px 30px 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue